import React from "react";
import { useTranslation } from "react-i18next";
import { registrationConstants } from "../../../constants";
import { useNavigate } from "react-router-dom";
import {
  MessageType,
  RegistrationStatus,
} from "../../../constants/notificationModal.constants";
import { Button } from "react-bootstrap";
import { translationConstants, viewPathConstants } from "../../../constants";

const NotificationModal = (props) => {
  const { registrationStatus, registrationMessage, resendEmail, messageType } =
    props;
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleContinue = () => {
    navigate(viewPathConstants.DEFAULT_PATH);
  };

  const renderStatusMessage = () => {
    switch (registrationStatus) {
      case RegistrationStatus.NOT_REQUESTED:
        // NotRequested
        return (
          <>
            <p className="UnderView">
              {t(translationConstants.thankYouForverification)}
            </p>
          </>
        );
      case RegistrationStatus.PENDING: // Pending
        return (
          <>
            <p className="UnderView">
              {t(translationConstants.thankYouForverification)}
            </p>
          </>
        );
      case RegistrationStatus.ALREADY_CONFIRMED: // Pending
        return (
          <>
            <span className="receivespan">
              {t(translationConstants.alreadyconfirmed)}
            </span>
          </>
        );
      default:
        return (
          <>
            <p className="UnderView">
              {t(translationConstants.thankYouForverification)}
            </p>
          </>
        );
    }
  };

  const renderMessage = () => {
    switch (messageType) {
      case MessageType.REGISTRATION_SUCCESSFUL: // NotRequested
        return (
          <>
            <p className="UnderView">
              {t(translationConstants.thankYouForRegistering)}
            </p>
            <span className="receivespan">
              {t(translationConstants.confirmationEmail)}
            </span>
          </>
        );
      case MessageType.DOCUMENTS_SUBMITTED:
        return (
          <>
            <p className="UnderView">
              {t(translationConstants.documentssubmitted)}
            </p>
            <span className="receivespan">
              {t(translationConstants.waitadminapproval)}
            </span>
          </>
        );
      default:
        return (
          <>
            <span></span>
          </>
        );
    }
  };
  return (
    <>
      {registrationMessage &&
      registrationMessage === registrationConstants.INVALID_TOKEN ? (
        <Button onClick={() => resendEmail} className="resendEmailBtn">
          Resend Email
        </Button>
      ) : //Here registration status 10 means, we custom dispatch the registration status in case of document submission.
      (registrationStatus === 0 || registrationStatus) &&
        registrationStatus !== 10 ? (
        renderStatusMessage()
      ) : (
        renderMessage()
      )}
      <span onClick={() => handleContinue()} className="GoBackPara text-decoration-underline">
        {t(translationConstants.continue)}
      </span>
    </>
  );
};

export default NotificationModal;
